import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const StudentTestimonials = ({ testimonials }) => {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
        {testimonials?.map((testimonial, index) => (
          <div
            key={index}
            className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6 hover:shadow-warm-md transition-smooth"
          >
            <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4">
              <div className="flex-shrink-0">
                <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
                  {testimonial?.name}
                </h4>
                <p className="text-xs md:text-sm text-muted-foreground font-caption">
                  {testimonial?.program} • {testimonial?.year}
                </p>
                <div className="flex items-center gap-1 mt-1.5 md:mt-2">
                  {[...Array(5)]?.map((_, i) => (
                    <Icon
                      key={i}
                      name={i < testimonial?.rating ? 'Star' : 'Star'}
                      size={14}
                      color={i < testimonial?.rating ? 'var(--color-accent)' : 'var(--color-muted)'}
                    />
                  ))}
                </div>
              </div>
            </div>
            <p className="text-sm md:text-base text-foreground font-caption leading-relaxed">
              "{testimonial?.content}"
            </p>
            <div className="flex items-center gap-2 mt-3 md:mt-4 pt-3 md:pt-4 border-t border-border">
              <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
              <span className="text-xs md:text-sm text-muted-foreground font-caption">
                {testimonial?.country}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="Users" size={24} color="var(--color-primary)" />
            </div>
            <div>
              <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
                Join Our Student Community
              </h4>
              <p className="text-sm md:text-base text-muted-foreground font-caption">
                Connect with current students and alumni from over 50 countries
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 md:px-6 py-2.5 md:py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-smooth whitespace-nowrap">
            <Icon name="MessageCircle" size={18} />
            <span className="text-sm md:text-base font-caption font-medium">Join Community</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentTestimonials;